'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { ContactUsFrom } from '@/components/ContactUsFrom';
export interface VehicleEnquireNowModalProps {
  onCompleteMessage?: string;
  vehicleStockId?: string;
  title?: string;
  siteId?: number;
}
export function VehicleEnquireNowModal(t0) {
  const $ = _c(14);
  const {
    onCompleteMessage,
    vehicleStockId,
    siteId,
    title
  } = t0;
  const [open, setOpen] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClickOpen = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button size="small" onClick={handleClickOpen}>Enquire Now</Button>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <DialogTitle>{title}</DialogTitle>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconButton aria-label="close" onClick={handleClose} sx={_temp}><CloseIcon /></IconButton>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onCompleteMessage || $[7] !== siteId || $[8] !== vehicleStockId) {
    t6 = <DialogContent><ContactUsFrom vehicleStockId={vehicleStockId} onCompleteMessage={onCompleteMessage} siteId={siteId} /></DialogContent>;
    $[6] = onCompleteMessage;
    $[7] = siteId;
    $[8] = vehicleStockId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== open || $[11] !== t4 || $[12] !== t6) {
    t7 = <>{t3}<Dialog open={open} onClose={handleClose}>{t4}{t5}{t6}</Dialog></>;
    $[10] = open;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(theme) {
  return {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500]
  };
}